import { BrowserRouter as Router } from 'react-router-dom';

import { createBrowserHistory } from 'history';
import ScrollToTop from 'components/common/ScrollToTop';
import RoutesIndex from 'routes';
import { Suspense } from 'react';

const history = createBrowserHistory();

function Routing() {
  return (
    <Router history={history}>
      <ScrollToTop />
      <Suspense fallback={<div />}>
        <RoutesIndex />
      </Suspense>
    </Router>
  );
}

export { Routing, history };
